import axios, { AxiosRequestConfig } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { mockCurrentUser } from '../__mocks__/mockCurrentUser';
import { environment } from '../environments/environment';
import mockData from './mockData.json';

if (process.env.NODE_ENV !== 'production' && environment.environmentName === 'development') {
  const mock = new MockAdapter(axios, { delayResponse: 500 });

  mock
    .onGet(
      `https://api.staging.qualio.com/v2/${mockCurrentUser.companyId}/users?company_id=${mockCurrentUser.companyId}`,
    )
    .reply(200, mockData.user);

  mock
    .onGet(`https://api.staging.qualio.com/document_templates?company_id=${mockCurrentUser.companyId}`)
    .reply(200, mockData.template);

  mockData.template.forEach((template: any) => {
    mock
      .onGet(
        `https://api.staging.qualio.com/v2/${mockCurrentUser.companyId}/template/${template.id}/next_document_code`,
      )
      .reply(200, `${template.document_id_prefix}${template.id}`);
  });

  mock
    .onGet(`https://api.staging.qualio.com/tags?company_id=${mockCurrentUser.companyId}`)
    .reply(200, mockData.tags);

  // Let everything else through
  mock.onAny().passThrough();
}

const defaultAxiosRequestConfig: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
};

export const medtechApiClient = axios.create({
  baseURL: environment.MEDTECH_API,
  withCredentials: true,
});

export const exportServiceClient = axios.create({
  ...defaultAxiosRequestConfig,
  baseURL: process.env.REACT_APP_EXPORT_SERVICE_URL,
});
